<template>
  <div :class="renderVariant" class="ls-provider-info-card--container">
    <div v-if="contractor.user.profile_image_url" class="ls-provider-info-card--avatar">
      <img :src="contractor.user.profile_image_url" />
    </div>
    <div v-else class="ls-provider-info-card--avatar">
      <img v-if="isLawnStarter" src="./assets/default.svg" />
      <img v-else src="./assets/default-2.svg" />
    </div>
    <div class="ls-provider-info-card--details-wrapper">
      <p class="ls-provider-info-card--name">
        {{ contractor.user | fullName }}, {{ contractor.name }}
      </p>
      <p>{{ contractor.city }}, {{ contractor.state }}</p>
      <LsBadge
        v-if="$attrs.status === 'hired'"
        bg-color="tertiary"
        :rounded="false"
        label="HIRED"
      />

      <LsProviderInfoCardDetails
        v-if="screenSize.desktop"
        :contractor="contractor"
        :property="property"
      />
    </div>
    <LsProviderInfoCardDetails
      v-if="!screenSize.desktop"
      :contractor="contractor"
      :property="property"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { mapState } from 'vuex';
import { lsPropTypeHelpers } from 'ls-vue-common';
import LsProviderInfoCardDetails from '@/components/LsProviderInfoCardDetails/LsProviderInfoCardDetails.vue';
import { LsBadge } from '@/components/common';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsProviderInfoCardMore',
  components: { LsProviderInfoCardDetails, LsBadge },
  mixins: [themedComponentMixin],
  props: {
    id: VueTypes.number,
    contractor: VueTypes.shape({
      bio: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
      user: VueTypes.shape({
        first_name: VueTypes.string,
        last_name: VueTypes.string,
        profile_image_url: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
      }).isRequired.loose,
      metrics: VueTypes.shape({
        ratings: VueTypes.shape({
          average: VueTypes.number.isRequired,
          is_top_performer: VueTypes.bool,
        }).isRequired.loose,
        response_time: VueTypes.shape({
          average: VueTypes.number.isRequired,
          is_fast: VueTypes.bool.isRequired,
        }).loose,
        customer_leads_hires: VueTypes.shape({
          lifetime: VueTypes.number.isRequired,
          is_high_demand: VueTypes.bool.isRequired,
        }).loose,
      }).isRequired,
      name: VueTypes.string,
      city: VueTypes.string,
      state: VueTypes.string,
      years_of_service: VueTypes.number,
    }).isRequired.loose,
    property: VueTypes.shape({
      id: VueTypes.number,
    }).loose,
  },
  computed: {
    ...mapState(['screenSize']),
    renderVariant() {
      return _.get(this.$router, 'currentRoute.matched[0].meta.isOnboarding', false)
        ? 'onboarding'
        : 'default';
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-provider-info-card--container {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  .ls-provider-info-card--avatar {
    display: flex;
    align-self: flex-start;
    flex-wrap: wrap;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    img {
      min-width: 80px;
      min-height: 60px;
      width: 80px;
    }
  }
  .ls-provider-info-card--name {
    font-weight: 700;
    font-size: 14px;
    max-width: 500px;
    @media (max-width: $mobile-max-width) {
      font-size: 12px;
      max-width: 240px;
    }
  }
}

// all routes other than onboarding
.onboarding .ls-provider-info-card--details-wrapper {
  .ls-provider-info-card--name {
    @media (max-width: $mobile-max-width) {
      max-width: 210px;
    }
  }
}
// all routes other than onboarding
.default .ls-provider-info-card--details-wrapper {
  max-width: 380px;
  @media (max-width: $mobile-max-width) {
    max-width: 320px;
  }
}
</style>
